import Overdue from '../../chart/overdue';
import InlineEditors from '../../controllers/inlineEditors';
import constants from '../../../../helpers/constants';
import rights from '../../../../components/rights';

const CLASSES_BY_COLUMN = {
  comments: ['notification_cell'],
  attachments: ['notification_cell'],
  text: getTextColumnClasses,
  status: ['status'],
  priority: ['priority'],
  resource_id: ['assign'],
  overdue: ['overdue'],
  end_date: getEndDateColumnClasses,
};

function getEndDateColumnClasses({ instance, task }) {
  const classes = [];

  if (Overdue.checkIsOverdue(task) && instance.config.highlight_overdue) {
    classes.push('overdue');
  }

  return classes;
}

function getTextColumnClasses({ instance, task }) {
  const classes = ['text_cell'];

  if (Overdue.checkIsOverdue(task) && instance.config.highlight_overdue) {
    classes.push('overdue');
  }

  if (+task.status === 4 && task.type !== 'project') {
    if (instance.config.cross_out_tasks) {
      classes.push('crossOutGrid-custom');
    }
    if (instance.config.discoloration_tasks) {
      classes.push('discolorationGrid');
    }
  }

  if (task.type !== instance.config.types.button && !instance.config.isArchived) {
    classes.push('tooltip-gantt');
  }

  return classes;
}

function getClassesByColumn(column, data) {
  if (CLASSES_BY_COLUMN[column.name] instanceof Function) {
    return CLASSES_BY_COLUMN[column.name](data);
  }

  if (CLASSES_BY_COLUMN[column.name]) {
    return CLASSES_BY_COLUMN[column.name];
  }

  return [];
}

/**
 * @param {Object} instance
 * @param {Object} task
 * @param {Object} column
 * @param {boolean} isLastColumn
 * @returns string
 */
export default function (instance, task, column, isLastColumn) {
  const isButtonRow = task.type === instance.config.types.button;
  const classes = ['gantt_cell'];

  if ((!rights.project.hasCostRight(task.gantt_id) && (column.name === 'total_price' || column.name === 'actual_cost'))) return classes.join(' ');

  if (isLastColumn) {
    classes.push('gantt_last_cell');
  }

  if (!isButtonRow && InlineEditors.hasEditor(column, task)) {
    classes.push('has_cell_inline_editor');
  }

  // TODO: Replace 4 with constant
  if (+task.status === 4 && task.type !== 'project') {
    const isLabelCustomColumn = column?.columnType === constants.CUSTOM_COLUMNS_TYPES.tags.id;

    if (instance.config.cross_out_tasks && !isLabelCustomColumn) {
      classes.push('crossOutGrid');
    }

    if (instance.config.discoloration_tasks) {
      classes.push('discolorationGrid');
    }
  }

  if (!instance.hasAccessToTask(task) || !instance.hasRightToEditField(task.gantt_id, column.data_type ? column.data_type : column.name)) {
    classes.push('cell_readonly');
  } else if (!isButtonRow && InlineEditors.isActive()) {
    if (+InlineEditors.getState().id === task.id && InlineEditors.getState().columnName === column.name) {
      classes.push('gantt_focused');
    }
  }

  classes.push(...getClassesByColumn(column, { instance, task, column }));

  return classes.join(' ');
}
